import ReactDOM from 'react-dom/client'
import './index.css'
import './ionic.css'
import App from './App'
import { AspProvider } from './providers/asp'
import { ConfigProvider } from './providers/config'
import { FiatProvider } from './providers/fiat'
import { FlowProvider } from './providers/flow'
import { NavigationProvider } from './providers/navigation'
import { NotificationsProvider } from './providers/notifications'
import { WalletProvider } from './providers/wallet'
import { OptionsProvider } from './providers/options'
import { LimitsProvider } from './providers/limits'
import { NudgeProvider } from './providers/nudge'
import * as Sentry from '@sentry/react'
import { LightningProvider } from './providers/lightning'
import { shouldInitializeSentry } from './lib/sentry'
import { FeesProvider } from './providers/fees'
import { AnnouncementProvider } from './providers/announcements'

// Initialize Sentry only in production and when DSN is provided
const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (shouldInitializeSentry(sentryDsn)) {
  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: false,
    enableLogs: true,
  })
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  // <React.StrictMode>
  <NavigationProvider>
    <NudgeProvider>
      <ConfigProvider>
        <AspProvider>
          <NotificationsProvider>
            <FiatProvider>
              <FlowProvider>
                <WalletProvider>
                  <LightningProvider>
                    <LimitsProvider>
                      <FeesProvider>
                        <OptionsProvider>
                          <AnnouncementProvider>
                            <App />
                          </AnnouncementProvider>
                        </OptionsProvider>
                      </FeesProvider>
                    </LimitsProvider>
                  </LightningProvider>
                </WalletProvider>
              </FlowProvider>
            </FiatProvider>
          </NotificationsProvider>
        </AspProvider>
      </ConfigProvider>
    </NudgeProvider>
  </NavigationProvider>,
  // </React.StrictMode>,
)
